import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

const Hero = ({ language }) => {
  const texts = {
    en: {
      badge: 'Streaming- und Download-Spiele',
      title: 'MobileHub4u',
      subtitle: 'MobileHub4u is an internet portal for streaming and download games for mobile devices. Enter your number and reply with JA (for Salt and Sunrise). The subscription costs CHF 10 per week (2 SMS/week for Salt, 1 SMS/week for Sunrise). To end the subscription, send an SMS with STOP TOP to 804 (Swisscom, Sunrise, Salt) or contact us: Hotline 0041 44 581 61 61, E-Mail gomobee.ch@silverlines.info.',
      cta: 'Start now',
      hint: 'GoMobee LTD · Adsaints B.V. – ch.nt.mobilehub4u.com',
    },
    de: {
      badge: 'Streaming- und Download-Spiele',
      title: 'MobileHub4u',
      subtitle: 'MobileHub4u ist ein Internetportal für Streaming- und Download-Spiele für Mobiltelefone und andere Endgeräte. Nummer eingeben und mit JA antworten (für Salt und Sunrise). Das Abo kostet CHF 10 pro Woche (2 SMS/Woche Salt, 1 SMS/Woche Sunrise). Abo kündigen: SMS mit STOP TOP an 804 (Swisscom, Sunrise, Salt) oder Hotline 0041 44 581 61 61, E-Mail gomobee.ch@silverlines.info.',
      cta: 'Jetzt starten',
      hint: 'GoMobee LTD · Adsaints B.V. – ch.nt.mobilehub4u.com',
    },
  };

  const t = texts[language];

  return (
    <section id="section-1" className="relative pt-28 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-slate-950" />
      <div className="absolute top-20 right-0 w-96 h-96 bg-brand-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-600/10 rounded-full blur-3xl" />

      <div className="relative max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 text-brand-400 text-sm font-medium">
              <Sparkles className="w-4 h-4" />
              {t.badge}
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              {t.title}
            </h1>
            <p className="text-lg sm:text-xl text-slate-400 max-w-xl leading-relaxed">
              {t.subtitle}
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-brand-500 text-white font-semibold hover:bg-brand-600 transition-colors"
              >
                {t.cta}
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
            <p className="text-slate-500 text-sm">
              {t.hint}
            </p>
          </div>

          <div className="relative flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md aspect-square rounded-2xl overflow-hidden bg-slate-800/50 border border-slate-700/50">
              <img
                src="/images/hero.jpeg"
                alt="MobileHub4u – Streaming- und Download-Spiele"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
